import {TrackingEvent as CollapsibleTrackingEvent} from 'common/components/collapsible/tracking';
import {TrackingEvent as CohortsQueryBuilderTrackingEvent} from 'common/widgets/cohorts-query-builder/util/tracking';
import {TRACKING_EVENTS as CustomPropertyModelTrackingEvent} from 'common/widgets/custom-property-modal/constants';
import {TRACKING_EVENTS as QueryBlockTrackingEvent} from 'common/widgets/query-block/constants';

import {
  FlattenedResourceTrackingEvent,
  TrackingEvent as EventSectionTrackingEvent,
} from '../query-entry-section/tracking';
import {TrackingEvent as PropertiesMenuTrackingEvent} from '../query-block/properties-menu/tracking';

export enum TrackingEvent {
  AddPropertyFilter = `Add property filter`,
  AddSegment = `Add segment`,
  ClearSegment = `Clear segment`,
  EditPropertyFilter = `Edit property filter`,
  EditSegment = `Edit segment`,
  RemovePropertyFilter = `Remove property filter`,
  RemoveSegment = `Remove segment`,
  ReorderSegment = `Reorder segment`,
  SelectDateRange = `Select date range`,
  SelectSegment = `Select segment`,
  SelectBreakdownAttribution = `Select breakdown attribution`,
  SelectFunnelsBreakdownAttribution = `Select funnels breakdown attribution`,
}

/** Defines tracking events that will be tracked as part of the query-builder */
export const CAPTURED_TRACKING = new Set<string>([
  CollapsibleTrackingEvent.ClosedCollapsibleSection,
  CollapsibleTrackingEvent.OpenedCollapsibleSection,
  TrackingEvent.ReorderSegment,
  ...FlattenedResourceTrackingEvent,
  ...Object.values(EventSectionTrackingEvent),
  ...Object.values(PropertiesMenuTrackingEvent),
  ...Object.values(CohortsQueryBuilderTrackingEvent),
  ...Object.values(CustomPropertyModelTrackingEvent),
  ...Object.values(QueryBlockTrackingEvent),
]);
